import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=e12e51c6&scoped=true"
import script from "./termsOfService.vue?vue&type=script&lang=js"
export * from "./termsOfService.vue?vue&type=script&lang=js"
import style0 from "./termsOfService.vue?vue&type=style&index=0&id=e12e51c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12e51c6",
  null
  
)

export default component.exports